// product grid/list
// function listgridJavascript() {
// Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
//     link.addEventListener('click', function(event) {
//         Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
//         this.classList.add('active');
//         if(this.classList.contains('listv')){
//             document.getElementById('product-grid').classList.add('product-list');
//             document.getElementById('product-grid').classList.remove('product-grid');
//         }else if(this.classList.contains('gridv')){
//             document.getElementById('product-grid').classList.add('product-grid');
//             document.getElementById('product-grid').classList.remove('product-list');
//         }
//     });
// });
// };
// document.addEventListener("shopify:section:load", listgridJavascript);
// listgridJavascript();


function layoutSwitcher() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', toggle);
    link.addEventListener('keydown', handleKeyDown);
  });
};
function handleKeyDown(event){
  if (event.keyCode === 13) {
    toggle(event);
  }
}
function toggle(event){
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
  event.currentTarget.classList.add('active');
  if(event.currentTarget.classList.contains('listv')){
    document.getElementById('ProductGridContainer').classList.add('product-list');
    document.getElementById('ProductGridContainer').classList.remove('product-grid');
  }else if(event.currentTarget.classList.contains('gridv')){
    document.getElementById('ProductGridContainer').classList.add('product-grid');
    document.getElementById('ProductGridContainer').classList.remove('product-list');
  }
}
document.addEventListener("shopify:section:load", layoutSwitcher);
layoutSwitcher();

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// timer
setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  countCardSections.forEach((countdownSection) => {
    var countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = "00";
      countdownSection.querySelector('.main_chours .wb_chours').textContent = "00";
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
    }
    else {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
      countdownSection.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
    }
  });
}

// TRANSLATE WITH JS
document.addEventListener("DOMContentLoaded", function() {
  
  // Add to wishlist
  const wishlistAddButton = document.querySelector(".xb-wishlist-button button");
  if (wishlistAddButton) wishlistAddButton.textContent = "Adaugă la wishlist";

  // Header
  const header = document.querySelector(".ezrv-widget_header h2");
  if (header) header.textContent = "Recenzii clienți";

  // Overall rating texts
  document.querySelectorAll(".ezrv-widget_overall_rating_content").forEach(el => {
    if (el.textContent.includes("out of")) {
      el.textContent = el.textContent.replace("out of", "din");
    }
    if (el.textContent.includes("Based on")) {
      el.textContent = el.textContent
        .replace("Based on", "Bazat pe")
        .replace("reviews", "recenzii");
    }
  });

  // Collected by EasyReviews
  const collected = document.querySelector("a[href*='easyreviews'] span");
  if (collected) collected.textContent = "Colectat de EasyReviews";

  // Buttons
  document.querySelectorAll(".ezrv-widget_summary_btn_write_review").forEach(btn => btn.textContent = "Scrie o recenzie");
  document.querySelectorAll(".ezrv-widget_summary_btn_cancel_review").forEach(btn => btn.textContent = "Anulează recenzia");
  document.querySelectorAll(".ezrv-widget_summary_btn_refresh_review").forEach(btn => btn.textContent = "Reîncarcă pagina");

  // Form labels
  document.querySelectorAll("label").forEach(label => {
    if (label.textContent.trim() === "Rating") label.textContent = "Evaluare";
    if (label.textContent.trim() === "Review") label.textContent = "Recenzie";
    if (label.textContent.trim() === "Review Title") label.textContent = "Titlul recenziei";
    if (label.textContent.trim().startsWith("Photo")) label.textContent = "Fotografie (opțional)";
    if (label.textContent.trim() === "Your Name") label.textContent = "Numele tău";
    if (label.textContent.trim() === "Your Email") label.textContent = "Emailul tău";
  });

  // Placeholders
  const title = document.querySelector(".ezrv-widget_review_submit_form h2");
  if (title) title.textContent = "Scrie o recenzie";

  const textarea = document.querySelector(".ezrv-widget_submit_review_content");
  if (textarea) textarea.placeholder = "Împărtășește detalii despre experiența ta";

  const titleInput = document.querySelector(".ezrv-widget_submit_review_title");
  if (titleInput) titleInput.placeholder = "Dă un titlu recenziei tale";

  const nameInput = document.querySelector(".ezrv-widget_submit_review_user_name");
  if (nameInput) nameInput.placeholder = "Introdu numele tău";

  const emailInput = document.querySelector(".ezrv-widget_submit_review_user_email");
  if (emailInput) emailInput.placeholder = "Introdu adresa ta de email (nu va fi publică)";

  // Form buttons
  document.querySelectorAll(".ezrv-widget_form_btn_cancel").forEach(btn => btn.textContent = "Anulează recenzia");
  document.querySelectorAll(".ezrv-widget_form_btn_submit").forEach(btn => btn.textContent = "Trimite recenzia");
});